import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, Subscription } from 'rxjs';
import { DropdownCalendarioComponent } from 'src/app/controls/dropdown-calendario/dropdown-calendario.component';
import { CadernoHomeOutputDto, EdicaoHomeOutputDto, ObterUltimaEdicaoECalendarioOutputDto} from 'src/app/domain/DTOs/output/jornal/ultima-edicao-e-calendario-para-home-output.dto';
import { obterUltimaEdicaoECalendario, obterUltimaEdicaoECalendarioFinish } from 'src/app/stateManagement/actions/Jornal/obter-ultima-edicao-e-calendario-para-home.action';
import { ObterUltimaEdicaoECalendarioState } from 'src/app/stateManagement/reducers/Jornal/obter-ultima-edicao-e-calendario-para-home.reducer';
import { selectDadosObterUltimaEdicaoECalendario } from 'src/app/stateManagement/selectors/Jornal/obter-ultima-edicao-e-calendario-para-home.selector';
import { ControlsModule } from "segov-sigepo-lib";
import { DateTime } from 'luxon';
import { listarEdicoesCalendarioState } from 'src/app/stateManagement/reducers/Jornal/listar-edicoes-para-calendario.reducer';
import { listarEdicoesCalendario, listarEdicoesCalendarioFinish } from 'src/app/stateManagement/actions/Jornal/listar-edicoes-para-calendario.action';
import { selectDadoslistarEdicoesCalendario } from 'src/app/stateManagement/selectors/Jornal/listar-edicoes-para-calendario.selector';
import { ListarEdicoesParaCalendarioInputDto } from 'src/app/domain/DTOs/input/jornal/listar-edicoes-para-calendario-input.dto';
import { CommonConverter } from 'src/app/utils/common.converter';
import { Cronogramas } from 'src/app/domain/modelsForComponents/cronograma.model';
import { SegovPage } from 'src/app/app.routes';
import { TransferirDadosParaEdicaoDoDiaParams } from 'src/app/domain/routeParamsModels/transferir-dados-para-edicao-do-dia.params';
import { CadernoOutputBaseDto } from 'src/app/domain/DTOs/output/jornal/caderno-output-base.dto';
import { SegovSigepoPesquisaFormComponent } from 'src/app/controls/segov-sigepo-pesquisa-form/segov-sigepo-pesquisa-form.component';
import { PesquisaBasicaJornalInputDto } from 'src/app/domain/DTOs/input/pesquisa-basica-jornal.input.dto';

@Component({
  selector: 'app-edicao-do-dia',
  standalone: true,
  imports: [
    SegovSigepoPesquisaFormComponent,
    DropdownCalendarioComponent,
    ControlsModule
  ],
  templateUrl: './edicao-do-dia.component.html',
  styleUrl: './edicao-do-dia.component.css'
})
export class EdicaoDoDiaComponent implements OnInit, OnDestroy {

  private subObterCalendarioHome: Subscription;
  private sublistarEdicoesCalendarios: Subscription;
  public dadosJornalHome: ObterUltimaEdicaoECalendarioOutputDto | undefined;
  public cronogramas: Cronogramas;
  public ultimaData: DateTime = DateTime.local();
  public exibeModalPesquisa = false;
  public creditoFoto = 'Foto: André Bernardes';

  constructor(
    private router: Router,
    private readonly storeObterCalendarioHome: Store<{ obterUltimaEdicaoECalendario: ObterUltimaEdicaoECalendarioState }>,
    private readonly storelistarEdicoesCalendario: Store<{ listarEdicoesCalendario: listarEdicoesCalendarioState }>
  ) {
    this.subObterCalendarioHome = new Subscription();
    this.sublistarEdicoesCalendarios = new Subscription();
    this.dadosJornalHome = new ObterUltimaEdicaoECalendarioOutputDto();
    this.cronogramas = {};
  }

  ngOnInit(): void {
    this.subObterCalendarioHome = this.storeObterCalendarioHome.select(selectDadosObterUltimaEdicaoECalendario)
      .pipe(filter(state => state !== null))
      .subscribe(response => {
        this.dadosJornalHome = response?.dados;
        this.cronogramas = CommonConverter.converterParaCronogramas(response?.dados?.edicoesCalendario);
        if (this.dadosJornalHome?.dataPublicacaoUltimaEdicao)
          this.ultimaData = DateTime.fromJSDate(new Date(this.dadosJornalHome?.dataPublicacaoUltimaEdicao));
      });

    this.sublistarEdicoesCalendarios = this.storelistarEdicoesCalendario.select(selectDadoslistarEdicoesCalendario)
      .pipe(filter(state => state !== null))
      .subscribe(response => {
        if (response) {
          this.cronogramas = CommonConverter.converterParaCronogramas(response?.dados);
        }
      });

    this.getDadosCalendarioHome();
  }

  ngOnDestroy(): void {
    this.subObterCalendarioHome.unsubscribe();
    this.sublistarEdicoesCalendarios.unsubscribe();
    this.storeObterCalendarioHome.dispatch(obterUltimaEdicaoECalendarioFinish());
    this.storelistarEdicoesCalendario.dispatch(listarEdicoesCalendarioFinish());
  }

  private getDadosCalendarioHome() {
    this.storeObterCalendarioHome.dispatch(obterUltimaEdicaoECalendario())
  }

  private getDadosCalendarioDoMes(data: Date) {
    const listarEdicoesCalendarioInputDto = new ListarEdicoesParaCalendarioInputDto(data.getMonth() + 1, data.getFullYear());
    this.storelistarEdicoesCalendario.dispatch(listarEdicoesCalendario({ listarEdicoesCalendarioInputDto }));
  }

  public obterData($event: Date) {
    const dadosParaEdicaoDoDia: TransferirDadosParaEdicaoDoDiaParams = {
      cronogramas: this.cronogramas,
      dataPublicacaoSelecionada: $event
    };
    this.goToEdicaoDoDia(dadosParaEdicaoDoDia);
  }

  public obterCadernoDoDia($event: CadernoOutputBaseDto) {
    const dadosParaEdicaoDoDia: TransferirDadosParaEdicaoDoDiaParams = {
      cronogramas: this.cronogramas,
      idCadernoEdicaoSelecionado: $event.id,
      edicaoSelecionada: $event,
      dataPublicacaoSelecionada: this.dadosJornalHome?.dataPublicacaoUltimaEdicao ? new Date(this.dadosJornalHome?.dataPublicacaoUltimaEdicao) : (new Date())
    }
    this.goToEdicaoDoDia(dadosParaEdicaoDoDia);
  }

  public obterCadernoHome(edicao: EdicaoHomeOutputDto, caderno: CadernoHomeOutputDto): void {
    const dadosParaEdicaoDoDia: TransferirDadosParaEdicaoDoDiaParams = {
      cronogramas: this.cronogramas,
      edicaoId: edicao.edicaoId,
      idCadernoEdicaoSelecionado: caderno.cadernoEdicaoId,
      dataPublicacaoSelecionada: new Date(edicao.dataPublicacao)
    };
    this.goToEdicaoDoDia(dadosParaEdicaoDoDia);
  }

  public obterPrimeiraEdicaoExtra(edicao: EdicaoHomeOutputDto): void {
    const primeiroCaderno = edicao.cadernos[0];
    if (!primeiroCaderno)
      return;

    this.obterCadernoHome(edicao, primeiroCaderno);
  }

  public goToUltimaEdicao() {
    this.router.navigate([SegovPage.EdicaoDoDia]);
  }

  private goToEdicaoDoDia(parametros: TransferirDadosParaEdicaoDoDiaParams) {
    this.router.navigate([SegovPage.EdicaoDoDia], { queryParams: { dados: JSON.stringify(parametros) } });
  }

  public goToPesquisa($event: PesquisaBasicaJornalInputDto) {
    this.router.navigate([SegovPage.PesquisaJornal], { queryParams: { dadosPesquisa: JSON.stringify($event) } });
  }

  public trocouMes($event: Date) {
    this.getDadosCalendarioDoMes($event);
  }

  public showModalPesquisa() {
    this.exibeModalPesquisa = true;
  }
}
